import React, { useState, useEffect } from "react";
import "./index.scss";

interface LightboxProps {
  className?: string;
  show: Boolean;
  callback?: Function;
  children: JSX.Element | JSX.Element[];
  onShow?: Function;
}

function Lightbox({
  children,
  show,
  callback,
  className,
  onShow
}: LightboxProps) {
  let [Show, toggleShow] = useState(false);
  const handleOnClick = () => {
    toggleShow(false);
    callback && callback();
  };
  const body = document.querySelector("body");

  if (show || (Show && !show)) {
    // disabled scroll on the body
    body!.style.height = "100%";
    body!.style.overflow = "hidden";
    body!.classList.add("lightbox-active");
  } else {
    // enable scroll on the body
    body!.style.height = "auto";
    body!.style.overflow = "";
    body!.classList.remove("lightbox-active");
  }

  useEffect(() => {
    if (show && onShow) {
      onShow();
    }
  }, [show]);

  // set fixed on the body
  return show || (Show && !show) ? (
    <div
      className={`lightbox ${className ? className : ""}`}
      onClick={e => {
        if (e.target === e.currentTarget) {
          handleOnClick();
        }
      }}
    >
      <div className="lightbox-container container">
        <div onClick={handleOnClick} className="lightbox__close" />
        {children}
      </div>
    </div>
  ) : (
    <div className="lightbox hide" />
  );
}

export default Lightbox;
